import React, {useState} from 'react';
import UseKnowledgeBank, {IKnowledgeBank} from '../../hooks/apis/useKnowledgeBank';
import {Button, Card, Checkbox, message, Modal, Space} from 'antd';
import UploadButton from '../UploadButton';
import Flex from '../Flex';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import {useAxios} from '../../utils/AxiosProvider';
const {confirm} = Modal;

export default function KnowledgeBankQuestionImport(props: {bank: IKnowledgeBank; onFinish: () => any}) {
  const getExcelTemplateState = UseKnowledgeBank.getExcelTemplate();
  const [loading, setLoading] = useState(false);
  const [isOverride, setIsOverride] = useState(false);
  function getExcelTemplate() {
    getExcelTemplateState
      .request({type: props.bank.type})
      .then(res => {
        window.open(res.url, '_blank');
      })
      .catch(CommonApiErrorHandler);
  }
  const axios = useAxios();
  function uploadFile(formData: FormData) {
    setLoading(true);
    formData.append('id', props.bank.id.toString());
    formData.append('isOverride', isOverride.toString());
    axios.instance
      .post<{
        errorMessage?: string;
        errorExcelUrl?: string;
        addCount: number;
        passCount: number;
        updateCount: number;
      }>('KnowledgeBank/importQuestion', formData, {})
      .then(res => {
        if (res.data.errorMessage) {
          confirm({
            title: res.data.errorMessage,
            content: res.data.errorExcelUrl && (
              <a href={res.data.errorExcelUrl} target={'_blank'}>
                下载错误标注 Excel
              </a>
            ),
          });
        } else {
          confirm({
            title: '导入完成',
            content: `新增 ${res.data.addCount} 题，修改 ${res.data.updateCount} 题，跳过 ${res.data.passCount} 题`,
          });
          props.onFinish();
        }
      })
      .catch(e => {
        message.error(e.message);
      })
      .finally(() => setLoading(false));
  }

  return (
    <Flex justify={'space-between'}>
      <Space>
        <UploadButton id={'UploadExcel'} label={'从 Excel 导入'} accept={'.xlsx'} loading={loading} upload={uploadFile} />
        <Checkbox className={'ml-md'} value={isOverride} onChange={e => setIsOverride(e.target.checked)}>
          序号相同时覆盖原题目（默认为跳过）
        </Checkbox>
      </Space>
      <Space>
        <a onClick={getExcelTemplate}>下载导入模板</a>
        {/*<a onClick={getExcelTemplate}>导出当前题库</a>*/}
      </Space>
    </Flex>
  );
}
